import * as React from 'react'

import { cn } from '@/lib/utils'
//This is the one used in the initial listing views, example details.
interface DataTableProps<T> {
  columns: string[]
  data: T[]
  renderRow: (_item: T) => React.ReactNode
  emptyMessage?: string
  className?: string
  onRowClick?: (_item: T) => void
  columnWidths?: string[]
  alignColumns?: boolean // If true, aligns first column left, middle center, last right
}

export function DataTable<T extends { id?: number | string }>({
  columns,
  data,
  renderRow,
  emptyMessage = 'No hay datos disponibles',
  className,
  onRowClick,
  columnWidths,
  alignColumns = false,
}: DataTableProps<T>) {
  return (
    <div
      className={cn('relative h-full overflow-auto bg-[#FAFAFA]', className)}
    >
      <table className="w-full border-collapse">
        <thead className="sticky top-0 z-10 border-b border-[#D4D4D4] bg-[#FAFAFA] shadow-sm">
          <tr>
            {columns.map((column, idx) => (
              <th
                className={cn(
                  'h-11 min-h-[44px] bg-[#FAFAFA] px-2 py-2 text-sm font-medium',
                  'text-[#262626]',
                  alignColumns
                    ? {
                        'text-left': idx === 0,
                        'text-center': idx !== 0 && idx !== columns.length - 1,
                        'text-right': idx === columns.length - 1,
                      }
                    : 'text-left'
                )}
                key={idx}
                style={
                  columnWidths?.[idx]
                    ? { width: columnWidths[idx], minWidth: columnWidths[idx] }
                    : undefined
                }
              >
                {column}
              </th>
            ))}
          </tr>
        </thead>
        <tbody className="bg-[#FAFAFA]">
          {data.length === 0 ? (
            <tr>
              <td
                className="px-3 py-8 text-center text-sm text-[#737373]"
                colSpan={columns.length}
              >
                {emptyMessage}
              </td>
            </tr>
          ) : (
            data.map((item, idx) => (
              <tr
                className={cn(
                  'border-b border-[#D4D4D4] transition-colors',
                  'hover:bg-[#F5F5F5]',
                  onRowClick && 'cursor-pointer'
                )}
                key={item.id || idx}
                onClick={() => onRowClick?.(item)}
              >
                {renderRow(item)}
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  )
}
